import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from '@angular/core';
import { HandleDates } from '@app/common/services/handle-dates.service';
import { PlexEnvironment } from '@app/env';
import { EnumerableResponse } from '@app/shared/models/dtos/enumerable-response';
import { IQtyTypeDto } from "@app/shared/models/dtos/qty-type";
import { IStandardConfigDto } from "@app/shared/models/dtos/standard-config";
import { IStandardConfigItemDto } from "@app/shared/models/dtos/standard-config-item";

@Injectable({
  providedIn: 'root'
})
export class StandardConfigManagementService {
  private http = inject(HttpClient);
  private handleDates = inject(HandleDates);
  public environment = inject(PlexEnvironment);

  private BASE_URL = '';

  constructor() {
    this.BASE_URL = this.environment.apiUrl;
  }

  public async findStandardConfigDtos(standardConfigurationId: number): Promise<EnumerableResponse<IStandardConfigDto>> {
    let url = `${this.BASE_URL}stdconfig/findstandardconfigs`;
    if (standardConfigurationId) url += `?standardConfigurationId=${standardConfigurationId}`;
    let result = this.http.get<EnumerableResponse<IStandardConfigDto>>(url).toPromise().then(x => this.handleDates.handleDates(x));
    return result;
  }

  public async upsertStandardConfigDtos(upsertIStandardConfigDtos: IStandardConfigSaveRequest): Promise<EnumerableResponse<IStandardConfigDto>> {
    let url = `${this.BASE_URL}stdconfig/upsertstandardconfigs`;
    let result = this.http.post<EnumerableResponse<IStandardConfigDto>>(url, upsertIStandardConfigDtos).toPromise().then(x => this.handleDates.handleDates(x));
    return result;
  }

  public async copyStandardConfigDtos(copyIStandardConfigDtos: IStandardConfigDto): Promise<boolean> {
    let url = `${this.BASE_URL}stdconfig/copyStdConfig/${copyIStandardConfigDtos.StandardConfigurationId}`;
    return this.http.post<boolean>(url, null).toPromise();
  }

  public async getStandardConfigurationQtyTypes(): Promise<EnumerableResponse<IQtyTypeDto>> {
    let url = `${this.BASE_URL}stdconfig/getstandardconfigurationqtytypes`;
    return this.http.get<EnumerableResponse<IQtyTypeDto>>(url).toPromise();
  }
}

export interface IStandardConfigSaveRequest {
  StandardConfigDtos: Array<IStandardConfigDto>;
  StandardConfigurationItemDtoUpserts: Array<IStandardConfigItemDto>;
  StandardConfigurationItemDtoRemoves: Array<IStandardConfigItemDto>;
}